
export default {
    name: 'Type',
    middleware: 'auth',
    mounted() {},
}
